export const initialVenditaTableData = {
    data:{
        data: [],
        totalElements: 0,
    },
    loading: false
}

export const initialNoleggioTableData = {
    data:{
        data: [],
        totalElements: 0,
    },
    loading: false
}

export const initialNoleggioInScadenzaTableData = {
    data: {
        data: [],
        totalElements: 0,
    },
    loading: false,
};

export const initialRestituzioniTableData = {
    data:{
        data: [],
        totalElements: 0,
    },
    loading: false
}

export const initialDeviceDetailsState = {
    data: {},
    loading: false
}

const countHelperObj = {
    count: 0,
    loading: false
}

export const initialTabsCountState = {
    vendita: countHelperObj,
    noleggio: countHelperObj,
    restituzioni: countHelperObj,
    noleggioInScadenza:countHelperObj
}

export const initialRestituzioniDetails = {
    data: {},
    loading: false
}

export const initialRestituzioniDetailsTableData = {
    data: {
        data: [],
        totalElements: 0,
    },
    loading: false
}